import http from "./HttpClient";
import { useStoreBase } from "../store";

http.interceptors.request.use((config) => {
  const paramConfig = config;
  const token = useStoreBase.getState().token;
  paramConfig.headers.Authorization = `Bearer ${token}`;

  if (paramConfig.data instanceof FormData) {
    if (typeof paramConfig.headers.delete === "function") {
      paramConfig.headers.delete("Content-Type");
      paramConfig.headers.delete("Content-type");
      paramConfig.headers.delete("content-type");
    } else {
      delete paramConfig.headers["Content-Type"];
      delete paramConfig.headers["Content-type"];
      delete paramConfig.headers["content-type"];
    }
  }

  return paramConfig;
});

// User-facing copy only ever shows plain Mongolian language — no error
// codes, stack traces, or raw server text. Full technical detail still goes
// to the console so it's available in devtools / bug reports.
function interceptError(error) {
  console.error("[API error]", error);

  if (error.response?.status === 401) {
    useStoreBase.setState({
      notification: {
        message:
          error.response?.data?.detail ||
          "Нэвтрэх эрх дууссан байна. Дахин нэвтэрнэ үү.",
        type: "warning",
      },
    });
    return;
  }

  if (error.response?.status >= 400 && error.response?.status < 500) {
    useStoreBase.setState({
      notification: {
        message:
          typeof error.response?.data?.detail === "string"
            ? error.response.data.detail
            : "Хүсэлт биелэгдсэнгүй. Мэдээллээ шалгаад дахин оролдоно уу.",
        type: "warning",
      },
    });
    return;
  }

  if (!error.response) {
    useStoreBase.setState({
      notification: {
        message: "Интернэт холболтоо шалгаад дахин оролдоно уу.",
        type: "error",
      },
    });
    return;
  }

  useStoreBase.setState({
    notification: {
      message: "Серверийн алдаа гарлаа. Түр хүлээгээд дахин оролдоно уу.",
      type: "error",
    },
  });
}

const get = (url, config) => {
  if (!config?.nonLoading) useStoreBase.setState({ loading: true });
  return http
    .get(url, config)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => {
      interceptError(error);
    })
    .finally(() => {
      if (!config?.nonLoading) useStoreBase.setState({ loading: false });
    });
};

const show = (url, config = {}) => {
  if (!config?.nonLoading) useStoreBase.setState({ loading: true });
  return http
    .get(url, config)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => {
      interceptError(error);
    })
    .finally(() => {
      if (!config?.nonLoading) useStoreBase.setState({ loading: false });
    });
};

const create = (url, payload, config = {}) => {
  if (!config?.nonLoading) useStoreBase.setState({ loading: true });
  return http
    .post(url, payload, config)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => {
      interceptError(error);
    })
    .finally(() => {
      if (!config?.nonLoading) useStoreBase.setState({ loading: false });
    });
};

const update = (url, payload, config = {}) => {
  if (!config?.nonLoading) useStoreBase.setState({ loading: true });
  return http
    .put(url, payload)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => {
      interceptError(error);
    })
    .finally(() => {
      if (!config?.nonLoading) useStoreBase.setState({ loading: false });
    });
};

const remove = (url, config = {}) => {
  if (!config?.nonLoading) useStoreBase.setState({ loading: true });
  return http
    .delete(url)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => {
      interceptError(error);
    })
    .finally(() => {
      if (!config?.nonLoading) useStoreBase.setState({ loading: false });
    });
};

const upload = (url, payload, config = {}) => {
  if (!config?.nonLoading) useStoreBase.setState({ loading: true });
  const uploadConfig = { ...config };

  if (payload instanceof FormData) {
    uploadConfig.headers = { ...(config.headers || {}) };
    delete uploadConfig.headers["Content-Type"];
    delete uploadConfig.headers["Content-type"];
    delete uploadConfig.headers["content-type"];
  }

  return http
    .post(url, payload, uploadConfig)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => {
      interceptError(error);
    })
    .finally(() => {
      if (!config?.nonLoading) useStoreBase.setState({ loading: false });
    });
};

const BaseService = {
  get,
  show,
  create,
  update,
  remove,
  upload,
};

export default BaseService;
